import React from 'react'
import Icon from '../Icon'
import { languageList } from '../Language'

import { isMainNetwork } from '_src/utils/chain'

export const exploreUrl = '/explore'

export const navs = (networkId, t, isMobile = false) => {
  const defaultNavs = [
    { label: t('menu.home'), icon: <Icon type="icon-menu-home" />, url: '/', key: '/' },
    {
      label: t('menu.mystery_box'),
      icon: <Icon type="icon-menu-mystery-box" />,
      url: '/mystery',
      key: '/mystery',
    },
    {
      label: t('menu.explore'),
      icon: <Icon type="icon-menu-collections" />,
      url: '/explore',
      key: '/explore',
      children: [
        {
          label: t('menu.marketplace'),
          url: '/marketplace',
          key: '/marketplace',
        },
        {
          label: t('menu.collections'),
          url: '/collections',
          key: '/collections',
        },
      ],
    },
  ]

  const create = {
    label: t('menu.create'),
    icon: <Icon type="icon-menu-create" />,
    url: '/create',
    key: '/create',
  }

  const language = {
    label: t('menu.language'),
    icon: <Icon type="icon-menu-language" />,
    key: '/language',
    children: [...languageList],
  }

  if (isMobile) {
    if (isMainNetwork(networkId)) {
      return [...defaultNavs, create, language]
    } else {
      return [...defaultNavs, language]
    }
  } else {
    if (isMainNetwork(networkId)) {
      return [...defaultNavs, create]
    }
  }

  return defaultNavs
}
